import { useItem } from '@/composables/item'
import { cisService } from '@/services/api'
import { defineStore, acceptHMRUpdate } from 'pinia'

export const useCisStore = defineStore('cis', () => {
	const { items, show, create, update, remove, attach, detach, getItem } =
		useItem<Api.Cis, Api.CisPostInput, Api.CisUpdateInput>(
			cisService,
			'cis',
			'Cis',
			{
				options: { saveCreated: false },
			}
		)

	return {
		getItem,
		items,
		show,
		create,
		update,
		remove,
		attach,
		detach,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useCisStore, import.meta.hot))
}
